import { WEEKDAYS_FR, MONTHS_SHORT_FR, BANDS } from './constants';

/**
 * Formatage de durées et dates pour l'affichage utilisateur (FR).
 * Pur, sans état.
 */

/**
 * Format long : "45 min", "2h", "3h45".
 * Utilisé dans la liste d'étapes et les détails de segment.
 */
export function fmtTime(min: number): string {
  const h = Math.floor(min / 60);
  const m = Math.round(min % 60);
  if (h === 0) return `${m} min`;
  if (m === 0) return `${h}h`;
  return `${h}h${String(m).padStart(2, '0')}`;
}

/**
 * Format compact pour récap : "45m", "2h", "3h45".
 * Idem que fmtTime mais "45m" au lieu de "45 min".
 */
export function fmtTimeCompact(min: number): string {
  const h = Math.floor(min / 60);
  const m = Math.round(min % 60);
  if (h === 0) return `${m}m`;
  if (m === 0) return `${h}h`;
  return `${h}h${String(m).padStart(2, '0')}`;
}

/** "Lun 17 mai" */
export function fmtDate(date: Date | null): string {
  if (!date) return '';
  return `${WEEKDAYS_FR[date.getDay()]} ${date.getDate()} ${MONTHS_SHORT_FR[date.getMonth()]}`;
}

/** "17/05" */
export function fmtDateShort(date: Date | null): string {
  if (!date) return '';
  return (
    String(date.getDate()).padStart(2, '0') +
    '/' +
    String(date.getMonth() + 1).padStart(2, '0')
  );
}

/** "09h00" */
export function fmtHour(date: Date | null): string {
  if (!date) return '';
  return (
    String(date.getHours()).padStart(2, '0') +
    'h' +
    String(date.getMinutes()).padStart(2, '0')
  );
}

/**
 * Renvoie l'INDEX (dans BANDS) de la bande temporelle correspondant à `minutes`.
 * -1 si au-delà de la dernière bande. Utilisé pour colorer un marqueur sur la carte.
 */
export function bandFor(minutes: number): number {
  for (let i = 0; i < BANDS.length; i++) {
    if (minutes <= BANDS[i].max * 60) return i;
  }
  return -1;
}
